export const thesesEn = {
  bachelorThesesList: [
          
   {
      name: `Broadleaved evergreen woody species in forests in the Košice surroundings: distribution and ecology`,
      link: `https://is.muni.cz/th/uphw5/`,
      author: "Juliana Szamosiová",
      year: "2025"
    },
   {
      name: `Natural non-forest vegetation of the Lúčanská Malá Fatra Mountains`,
      link: `https://is.muni.cz/th/ppy6o/`,
      author: "Branislav Vrábel",
      year: "2024"
    },		  {
      name: `Successional trajectory after the restoration of formerly afforested dry grasslands of the Tematín hills (Slovakia)`,
      link: `https://is.muni.cz/th/cxkvc/`,
      author: "Branislav Kopčan",
      year: "2024"
    },
		   {
      name: `Vegetation of the Křtinský potok valley and its dynamics`,
      link: `https://is.muni.cz/th/ors8k/`,
      author: "Jaroslav Rohel",
      year: "2023"
    },
		   {
      name: `Long-term vegetation changes in selected forest areas in the Beskydy foothills`,
      link: `https://is.muni.cz/th/pjbif/`,
      author: "Štěpánka Pustková",
      year: "2022"
    },
	       {
      name: `Invasion of Mahonia aquifolium in the city of Brno`,
      link: `https://is.muni.cz/th/vxcs9/`,
      author: "Vojtěch Sobotka",
      year: "2022"
    },
	       {
      name: `Forest vegetation of the southern part of the Podkomorské lesy Nature Park`,
      link: `https://is.muni.cz/th/wjlia/`,
      author: "Natália Janišová",
      year: "2022"
    },
		       {
      name: `Ecological interaction between hemiparasitic Melampyrum arvense and invasive Erigeron annuus`,
      link: `https://is.muni.cz/th/cjl5e/`,
      author: "Terezie Chamrátová",
      year: "2022"
    },
      {
      name: `The effect of former ploughing on grassland species composition in the Hutě Nature Reserve (White Carpathians)`,
      link: `https://is.muni.cz/th/v60d7/?lang=en`,
      author: "Karolína Slachová",
      year: "2020"
    },
    {
      name: `Flora and vegetation of area near Mokrá-Horákov east of the Brno city`,
      link: `https://is.muni.cz/th/ba4ml/?lang=en`,
      author: "Marcel Bartoš",
      year: "2019"
    },
    {
      name: `Vegetation around the western part of the Brno Reservoir`,
      link: `https://is.muni.cz/th/sw165/?lang=en`,
      author: "Martin Harásek",
      year: "2019"
    },
    {
      name: `Structure of exposure-related forest-steppe in Central Europe`,
      link: `https://is.muni.cz/th/tq01u/?lang=en`,
      author: "Kryštof Chytrý",
      year: "2019"
    },
    {
      name: `Vegetation succession on disused railways in the eastern part of the Czech Republic`,
      link: `https://is.muni.cz/th/h0k5v/?lang=en`,
      author: "Filip Kratoš",
      year: "2019"
    },
    {
      name: `Species richness of selected vegetation types: comparison of modelled and observed numbers of species`,
      link: `https://is.muni.cz/th/pefba/?lang=en`,
      author: "Andrea Lobpreisová",
      year: "2019"
    },
    {
      name: `Distribution of Oxalis corniculata, O. dillenii and O. stricta in the Czech Republic as documented by herbarium specimens in some public collections`,
      link: `https://is.muni.cz/th/fqiqn/?lang=en`,
      author: "Jan Dohnal",
      year: "2018"
    },
  ],

  masterThesesList: [
  {
      name: `Effect of prescribed range burning on grassland vegetation`,
      link: `https://is.muni.cz/th/c97nn/?fakulta=1422;obdobi=3823;lang=en%2F;id=125290`,
      author: "Terezie Chamrátová",
      year: "2025"
    },
	{
      name: `Forest vegetation of the Považský Inovec Mts`,
      link: `https://is.muni.cz/th/d12y3/?lang=en;id=261076`,
      author: "Natália Janišová",
      year: "2025"
    },
  {
      name: `Succession of steppe vegetation in abandoned fields in South Moravia`,
      link: `https://is.muni.cz/th/azlun/?lang=cs;cop=3437685;id=250056`,
      author: "Vojtěch Sobotka",
      year: "2024"
    },
	{
      name: `Flora and vegetation of restored wetlands in southern Moravia`,
      link: `https://is.muni.cz/th/esvr7/?vysl=21710;id=226586`,
      author: "Štěpánka Pustková",
      year: "2024"
    },
		{
      name: `Variability of plant traits in urbanized area of Brno`,
      link: `https://is.muni.cz/th/c5ftz/?info`,
      author: "Andrea Lobpreisová",
      year: "2023"
    },
        {
      name: `Tall-herb vegetation of the south Moravian forest-steppe`,
      link: `https://is.muni.cz/th/hauzn/`,
      author: "Klára Klinkovská",
      year: "2022"
    },
	      {
      name: `Alpine and subalpine vegetation of Mt Midzhur, Stara Planina, Bulgaria`,
      link: `https://is.muni.cz/th/qzsj5/`,
      author: "Daniel Szokala",
      year: "2022"
    },
      {
      name: `Flora of selected mining sites of White Carpathians Mts.`,
      link: `https://is.muni.cz/th/jqnqg/?lang=en`,
      author: "Eliška Kundratová",
      year: "2020"
    },
    {
      name: `Alpine vegetation of Mount Smolikas (Greece) and Mount Nemërçkë (Albania)`,
      link: `https://is.muni.cz/th/nwy2q/?lang=en`,
      author: "Mário Duchoň",
      year: "2018"
    },
    {
      name: `Flora and vegetation of the Bílá voda catchment in the Drahanská vrchovina Mountains`,
      link: `https://is.muni.cz/th/yefy1/?lang=en`,
      author: "Pavla Vlčková",
      year: "2018"
    },
    {
      name: `Local species richness of natural vegetation in the deep river valleys of the Bohemian Massif`,
      link: `https://is.muni.cz/th/oeak6/?lang=en`,
      author: "Jaroslav Hruban",
      year: "2017"
    },
    {
      name: `Flora of selected area on western margin of Brno`,
      link: `https://is.muni.cz/th/iu4t7/?lang=en`,
      author: "Martina Staviařová",
      year: "2017"
    },
    {
      name: `Effect of alien deciduous woody plants on herb-layer diversity`,
      link: `https://is.muni.cz/th/hpzms/?lang=en`,
      author: "Milan Šenkýř",
      year: "2015"
    }
  ],

  phdThesesList: [
   {
      name: `Microhabitats of lignicolous fungi`,
      link: `https://is.muni.cz/th/ikvy5/Thesis_Kolenyova_HIDDEN_PART.pdf?info=1`,
      author: "Monika Kolényová",
      year: "2026"
    },
  {
      name: `Changes in vegetation and flora of the Czech Republic`,
      link: `https://is.muni.cz/th/b9gpr/`,
      author: "Klára Friesová (Klinkovská)",
      year: "2026"
    }, 
  {
      name: `Interactions between hemiparasites and invasive plants of grassland habitats`,
      link: `https://is.muni.cz/th/jrpk1/`,
      author: "Kateřina Knotková",
      year: "2025"
    },  
{
      name: `Diversity patterns in European vegetation: Linking community ecology and macroecology`,
      link: `https://is.muni.cz/th/xpz2o/?lang=en`,
      author: "Martin Večeřa",
      year: "2021"
    },  
{
      name: `Tree-soil interactions in natural temperate forests in space and time`,
      link: `https://is.muni.cz/th/c1hb6/?lang=en`,
      author: "Pavel Daněk",
      year: "2021"
    }, 	
	 {
      name: `Determinants of spatial patterns in composition of plant communities`,
      link: `https://is.muni.cz/th/qmtgr/`,
      author: "Markéta Chudomelová",
      year: "2020"
    },
	{
      name: `Diversity and ecology of the river gravel-bar vegetation`,
      link: `https://is.muni.cz/th/sxp8e/?lang=en`,
      author: "Veronika Kalníková",
      year: "2020"
    },
	    {
      name: `Vegetation of European oak-hornbeam forests`,
      link: `https://is.muni.cz/th/we4du/?lang=en`,
      author: "Pavel Novák",
      year: "2020"
    },
    {
      name: `Diversity and ecology of epiphytic bryophyte communities on dead wood in forest nature reserves`,
      link: `https://is.muni.cz/th/eqf1z/`,
      author: "Markéta Táborská",
      year: "2018"
    },
    {
      name: `Diversity of European urban vegetation`,
      link: `https://is.muni.cz/th/l2m0i/`,
      author: "Natálie Čeplová",
      year: "2017"
    },
    {
      name: `Environmental drivers of fine-scale plant species richness in Eurasian dry grasslands: a macroecological perspective`,
      link: `https://is.muni.cz/th/pqmhh/`,
      author: "Salza Palpurina",
      year: "2017"
    },
    {
      name: `Spatial distribution of small scale vegetation diversity in the landscape`,
      link: `https://is.muni.cz/th/qh9b3/?lang=cs`,
      author: "Dana Michalcová (Holubová)",
      year: "2016"
    },
    {
      name: `Traditional management and its impact on the vegetation of open lowland woodlands`,
      link: `https://is.muni.cz/th/pyveg/`,
      author: "Ondřej Vild",
      year: "2016"
    },
    {
      name: `Alien plant invasions in habitats: intercontinental comparison`,
      link: `https://is.muni.cz/th/iiosh/`,
      author: "Veronika Kalusová",
      year: "2015"
    },
    {
      name: `The effect of phenological changes on vegetation data sampling and analyses`,
      link: `https://is.muni.cz/th/zgrjc/`,
      author: "Marie Vymazalová",
      year: "2014"
    },
    {
      name: `Diversity of mountain forest vegetation in Taiwan`,
      link: `https://is.muni.cz/th/fhgaf/`,
      author: "Ching-Feng Li",
      year: "2013"
    },
    {
      name: `Environmental control of diversity of Central European grasslands`,
      link: `https://is.muni.cz/th/gyqwk/`,
      author: "Kristina Merunková",
      year: "2013"
    },
    {
      name: `The effect of productivity and other environmental factors on the forest herb-layer diversity`,
      link: `https://is.muni.cz/th/g64sa/?lang=cs`,
      author: "Irena Axmanová",
      year: "2012"
    },
	{
      name: `Segetal vegetation of northern and central Moravia`,
      link: `https://is.muni.cz/th/go9pc/?lang=en`,
      author: "Šárka Cimalová",
      year: "2009"
    },
	 {
      name: `Diversity of perennial ruderal and trampled vegetation of the Czech Repulic`,
      link: `https://is.muni.cz/th/w6som/?lang=en`,
      author: "Deana Láníková",
      year: "2009"
    },
	 {
      name: `Vegetation of subcontinental oak forests in Central and Eastern Europe`,
      link: `https://is.muni.cz/th/flx1t/?lang=en`,
      author: "Jan Roleček",
      year: "2007"
    },
	 {
      name: `Variability of the Molinion meadows in the Czech and Slovak Republics`,
      link: `https://is.muni.cz/th/tp2ys/?lang=en`,
      author: "Marcela Řezníčková",
      year: "2007"
    },
	 {
      name: `Plant communities of periodically flooded eulittoral of standing and running waters in the Czech Republic`,
      link: `https://is.muni.cz/th/egg4f/?lang=en`,
      author: "Kateřina Šumberová",
      year: "2006"
    },
	{
      name: `The influence of the sample plot size on the analyses of vegetation diversity`,
      link: `https://is.muni.cz/th/ish7j/?lang=en`,
      author: "Zdenka Otýpková (Preislerová)",
      year: "2006"
    }, 
	{
      name: `Local and large-scale data sets and their use for vegetation classification`,
      link: `https://is.muni.cz/th/h5dbe/?lang=en`,
      author: "Ilona Knollová",
      year: "2006"
    }, 
	
  ],

  thesesTitle: "Theses topics",
  bachelorTheses: "Bachelor Theses (examples)",
  masterTheses: "Master Theses (examples)",
  phdTheses: "PhD Theses"
};

export const thesesCz = {
  bachelorThesesList: [
   {
      name: `Širokolisté stálezelené dřeviny v lesích v okolí Košic: rozšíření a ekologie`,
      link: `https://is.muni.cz/th/uphw5/`,
      author: "Juliana Szamosiová",
      year: "2025"
    },
   {
      name: `Přirozená nelesní vegetace Lúčanské Malé Fatry`,
      link: `https://is.muni.cz/th/ppy6o/`,
      author: "Branislav Vrábel",
      year: "2024"
    },		  {
      name: `Sukcesní vývoj po obnově zalesněných suchých trávníků v Tematínských vrších na Slovensku`,
      link: `https://is.muni.cz/th/cxkvc/`,
      author: "Branislav Kopčan",
      year: "2024"
    },
		   {
      name: `Vegetace údolí Křtinského potoka a její dynamika`,
      link: `https://is.muni.cz/th/ors8k/`,
      author: "Jaroslav Rohel",
      year: "2023"
    },
         {
      name: `Dlouhodobé změny vegetace vybraných lesních komplexů Beskydského podhůří`,
      link: `https://is.muni.cz/th/pjbif/`,
      author: "Štěpánka Pustková",
      year: "2022"
    },
	       {
      name: `Invaze mahónie cesmínolisté (Mahonia aquifolium) na území města Brna`,
      link: `https://is.muni.cz/th/vxcs9/`,
      author: "Vojtěch Sobotka",
      year: "2022"
    },
	       {
      name: `Lesní vegetace jižní části přírodního parku Podkomorské lesy`,
      link: `https://is.muni.cz/th/wjlia/`,
      author: "Natália Janišová",
      year: "2022"
    },
			{
      name: `Ekologická interakce mezi poloparazitickým černýšem rolním (Melampyrum arvense) a invazním turanem ročním (Erigeron annuus)`,
      link: `https://is.muni.cz/th/cjl5e/`,
      author: "Terezie Chamrátová",
      year: "2022"
    },
        {
      name: `Vliv minulé orby na druhové složení luk v PR Hutě v Bílých Karpatech`,
      link: `https://is.muni.cz/th/v60d7/`,
      author: "Karolína Slachová",
      year: "2020"
    },
    {
      name: `Flóra a vegetace území v okolí obce Mokrá-Horákov východně od Brna`,
      link: `https://is.muni.cz/th/ba4ml/`,
      author: "Marcel Bartoš",
      year: "2019"
    },
    {
      name: `Vegetace v okolí západní části Brněnské přehrady`,
      link: `https://is.muni.cz/th/sw165/`,
      author: "Martin Harásek",
      year: "2019"
    },
    {
      name: `Struktura expoziční lesostepi ve střední Evropě`,
      link: `https://is.muni.cz/th/tq01u/`,
      author: "Kryštof Chytrý",
      year: "2019"
    },
    {
      name: `Sukcese vegetace na zrušených železničních tratích ve východní části České republiky`,
      link: `https://is.muni.cz/th/h0k5v/?lang=cs`,
      author: "Filip Kratoš",
      year: "2019"
    },
    {
      name: `Druhová bohatost vybraných vegetačních typů: srovnání modelovaného a pozorovaného počtu druhů`,
      link: `https://is.muni.cz/th/pefba/?lang=cs`,
      author: "Andrea Lobpreisová",
      year: "2019"
    },
    {
      name: `Rozšíření šťavelů Oxalis corniculata, O. dillenii a O. stricta v České republice podle herbářových dokladů ve vybraných veřejných sbírkách`,
      link: `https://is.muni.cz/th/fqiqn/`,
      author: "Jan Dohnal",
      year: "2018"
    },
  ],

  masterThesesList: [
  {
      name: `Vliv řízeného vypalování na stepní a luční vegetaci`,
      link: `https://is.muni.cz/th/c97nn/?fakulta=1422;obdobi=3823;lang=en%2F;id=125290`,
      author: "Terezie Chamrátová",
      year: "2025"
    },
	{
      name: `Lesní vegetace Považského Inovce`,
      link: `https://is.muni.cz/th/d12y3/?lang=cs;id=261076`,
      author: "Natália Janišová",
      year: "2025"
    },
  {
      name: `Sukcese stepní vegetace na opuštěných polích jižní Moravy`,
      link: `https://is.muni.cz/th/azlun/?lang=cs;cop=3437685;id=250056`,
      author: "Vojtěch Sobotka",
      year: "2024"
    },
	{
      name: `Flóra a vegetace revitalizovaných mokřadů na jižní Moravě`,
      link: `https://is.muni.cz/th/esvr7/?vysl=21710;id=226586`,
      author: "Štěpánka Pustková",
      year: "2024"
    },
		{
      name: `Variabilita rostlinných vlastností v urbánním prostoru Brna`,
      link: `https://is.muni.cz/th/c5ftz/?info`,
      author: "Andrea Lobpreisová",
      year: "2023"
    },
          {
      name: `Vysokobylinná vegetace jihomoravské lesostepi`,
      link: `https://is.muni.cz/th/hauzn/`,
      author: "Klára Klinkovská",
      year: "2022"
    },
	      {
      name: `Alpínská a subalpínská vegetace hory Midžur, Stara planina, Bulharsko`,
      link: `https://is.muni.cz/th/qzsj5/`,
      author: "Daniel Szokala",
      year: "2022"
    },
      {
      name: `Květena vybraných lomů v Bílých Karpatech`,
      link: `https://is.muni.cz/th/jqnqg/`,
      author: "Eliška Kundratová",
      year: "2020"
    },
    {
      name: `Alpínská vegetace pohoří Smolikas v Řecku a Nemërçkë v Albánii`,
      link: `https://is.muni.cz/th/nwy2q/`,
      author: "Mário Duchoň",
      year: "2018"
    },
    {
      name: `Flóra a vegetace povodí Bílé vody na Drahanské vrchovině`,
      link: `https://is.muni.cz/th/yefy1/?lang=cs`,
      author: "Pavla Vlčková",
      year: "2018"
    },
    {
      name: `Lokální druhové bohatství přirozené vegetace hlubokých říčních údolí Českého masivu`,
      link: `https://is.muni.cz/th/oeak6/?lang=cs`,
      author: "Jaroslav Hruban",
      year: "2017"
    },
    {
      name: `Flóra vybraného územi na západním okraji Brna`,
      link: `https://is.muni.cz/th/iu4t7/`,
      author: "Martina Staviařová",
      year: "2017"
    },
    {
      name: `Vliv nepůvodních listnatých dřevin na diverzitu bylinného patra`,
      link: `https://is.muni.cz/th/hpzms/`,
      author: "Milan Šenkýř",
      year: "2015"
    }
  ],

  phdThesesList: [
   {
      name: `Mikrohabitaty lignikolních druhů hub`,
      link: `https://is.muni.cz/th/ikvy5/Thesis_Kolenyova_HIDDEN_PART.pdf?info=1`,
      author: "Monika Kolényová",
      year: "2026"
    },
  {
      name: `Změny vegetace a flóry České republiky`,
      link: `https://is.muni.cz/th/b9gpr/`,
      author: "Klára Friesová (Klinkovská)",
      year: "2026"
    },
   {
      name: `Interakce mezi poloparazitickými a invazními rostlinami v travinných společenstvech`,
      link: `https://is.muni.cz/th/jrpk1/`,
      author: "Kateřina Knotková",
      year: "2025"
    }, 
      {
      name: `Diverzita evropské vegetace: Propojení ekologie společenstev a makroekologie`,
      link: `https://is.muni.cz/th/xpz2o/?lang=cs`,
      author: "Martin Večeřa",
      year: "2021"
    }, 
	{
      name: `Interakce mezi stromy a půdou v přirozených temperátních lesích v prostoru a čase`,
      link: `https://is.muni.cz/th/c1hb6/`,
      author: "Pavel Daněk",
      year: "2021"
    }, 
	  {
      name: `Faktory ovlivňující prostorovou strukturu ve složení rostlinných společenstev`,
      link: `https://is.muni.cz/th/qmtgr/`,
      author: "Markéta Chudomelová",
      year: "2020"
    },
        {
      name: `Diverzita a ekologie vegetace štěrkových říčních náplavů`,
      link: `https://is.muni.cz/th/sxp8e/`,
      author: "Veronika Kalníková",
      year: "2020"
    },
	    {
      name: `Vegetace evropských dubohabřin`,
      link: `https://is.muni.cz/th/we4du/`,
      author: "Pavel Novák",
      year: "2020"
    },
    {
      name: `Diverzita a ekologie společenstev epifytických mechorostů na mrtvém dřevě v lesních rezervacích`,
      link: `https://is.muni.cz/th/eqf1z/`,
      author: "Markéta Táborská",
      year: "2018"
    },
    {
      name: `Diverzita vegetace evropských měst`,
      link: `https://is.muni.cz/th/l2m0i/`,
      author: "Natálie Čeplová",
      year: "2017"
    },
    {
      name: `Vliv faktorů prostředí na lokální druhové bohatství rostlin v eurasijských suchých trávnících: makroekologická perspektiva`,
      link: `https://is.muni.cz/th/pqmhh/`,
      author: "Salza Palpurina",
      year: "2017"
    },
    {
      name: `Prostorové rozmístění maloplošné diverzity vegetace v krajině`,
      link: `https://is.muni.cz/th/qh9b3/?lang=cs`,
      author: "Dana Michalcová (Holubová)",
      year: "2016"
    },
    {
      name: `Tradiční management a jeho vliv na vegetaci podrostu světlých lesů nížin`,
      link: `https://is.muni.cz/th/pyveg/`,
      author: "Ondřej Vild",
      year: "2016"
    },
    {
      name: `Invaze nepůvodních druhů rostlin v biotopech: mezikontinentální srovnání`,
      link: `https://is.muni.cz/th/iiosh/`,
      author: "Veronika Kalusová",
      year: "2015"
    },
    {
      name: `Vliv fenologických změn vegetace na sběr a analýzu vegetačních dat`,
      link: `https://is.muni.cz/th/zgrjc/`,
      author: "Marie Vymazalová",
      year: "2014"
    },
    {
      name: `Diverzita horské lesní vegetace na Tchaj-wanu`,
      link: `https://is.muni.cz/th/fhgaf/`,
      author: "Ching-Feng Li",
      year: "2013"
    },
    {
      name: `Vliv prostředí na diverzitu středoevropské travinné vegetace`,
      link: `https://is.muni.cz/th/gyqwk/`,
      author: "Kristina Merunková",
      year: "2013"
    },
    {
      name: `Vliv produktivity a dalších faktorů prostředí na diverzitu bylinného patra lesů`,
      link: `https://is.muni.cz/th/g64sa/?lang=cs`,
      author: "Irena Axmanová",
      year: "2012"
    },
	{
      name: `Segetální vegetace severní a střední Moravy`,
      link: `https://is.muni.cz/th/go9pc/`,
      author: "Šárka Cimalová",
      year: "2009"
    },
	 {
      name: `Diverzita vytrvalé ruderální a sešlapávané vegetace České republiky`,
      link: `https://is.muni.cz/th/w6som/`,
      author: "Deana Láníková",
      year: "2009"
    },
	 {
      name: `Vegetace subkontinentálních doubrav ve střední a východní Evropě`,
      link: `https://is.muni.cz/th/flx1t/`,
      author: "Jan Roleček",
      year: "2007"
    },
	 {
      name: `Variabilita luk svazu Molinion v České a Slovenské republice`,
      link: `https://is.muni.cz/th/tp2ys/`,
      author: "Marcela Řezníčková",
      year: "2007"
    },
	 {
      name: `Rostlinná společenstva dočasně zaplavovaného eulitorálu stojatých a tekoucích vod v ČR`,
      link: `https://is.muni.cz/th/egg4f/`,
      author: "Kateřina Šumberová",
      year: "2006"
    },
	{
      name: `Vliv velikosti ploch pro sběr dat na fytocenologickou klasifikaci vegetace`,
      link: `https://is.muni.cz/th/ish7j/`,
      author: "Zdenka Otýpková (Preislerová)",
      year: "2006"
    }, 
	{
      name: `Lokální a velkoplošné datové soubory a jejich využití pro klasifikaci vegetace`,
      link: `https://is.muni.cz/th/h5dbe/`,
      author: "Ilona Knollová",
      year: "2006"
    }, 
  ],

  thesesTitle: "Témata prací",
  bachelorTheses: "Balakářské práce (výběr)",
  masterTheses: "Magisterské práce (výběr)",
  phdTheses: "Disertační práce"
};
